// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__ZbuD+","dot":"styles_dot__HZDP0","spinner":"styles_spinner__imErA"};